import React from 'react';
import { motion } from 'framer-motion';
export function FloatingCTA() {
  const scrollToPrice = () => {
    document.getElementById('price-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <motion.div initial={{
    opacity: 0,
    y: 50
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: 1
  }} className="fixed bottom-6 right-6 z-50" data-id="element-34">
      <button onClick={scrollToPrice} className="bg-warm-accent hover:bg-[#8A4525] text-white font-bold py-4 px-8 rounded-full shadow-floating transition-all duration-300 text-sm tracking-wide border border-white/20 hover:scale-105" data-id="element-35">
        SÍ, QUIERO EL ESCUDO
      </button>
    </motion.div>;
}